import React, {useEffect, useState} from 'react'
import { makeStyles } from '@material-ui/core/styles';
import PriceFormat from "react-number-format";

import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import Tooltip from "@material-ui/core/Tooltip/Tooltip"
import IconButton from "@material-ui/core/IconButton"
import blue from "@material-ui/core/colors/blue"
import Divider from "@material-ui/core/Divider"
import TextField from "@material-ui/core/TextField/TextField"
import MenuItem from "@material-ui/core/MenuItem"
import Slider from "@material-ui/core/Slider"
import Input from "@material-ui/core/Input";
import Typography from "@material-ui/core/Typography"
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction/ListItemSecondaryAction"

import AjaxLoading from "../../AjaxLoading";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons'

import {_t} from '../../../i18n/lang'

const cache = new Map()

const useStyles = makeStyles({
    sliderLabel: {
        color: "rgba(0, 0, 0, 0.54)",
        margin: 0,
        fontSize: "0.75rem",
        marginTop: "10px"
    },
    sliderWrap: {
        width: '80%'
    },
    fieldWrap: {
        width: '15%',
        marginLeft: '4%',
        top: '-2.1em'
    },
    title: {
        marginTop: '20px',
        fontWeight: 'bold',
        width: '100%',
        maxWidth: 500,
    },
});

export default function CartDetails(props) {
    const classes = useStyles()
    const [details, setDetails] = useState([])
    const [loading, setLoading] = useState(false)
    const {
        projectId,
        addProjectDetails,
        editProjectDetailQty,
        removeDetailFromProject,
        editProjectDetailVendorIdentifier,
        showVendorIdentifier,
        priceInPln,
        customDetails
    } = props

    useEffect( () => {
        setDetails(customDetails)
    })


    const removeDetail = (projectId, part) => {
        const newDetails = details.filter(row => row.part !== part)
        setDetails(newDetails)
        removeDetailFromProject(projectId, part)
    }

    const handleChange = (event) => {
        const { name, value } = event.target
        editProjectDetailQty(projectId, name, value)
    };

    const handleVendorIdentifierChange = (event) => {
        const { name, value } = event.target
        editProjectDetailVendorIdentifier(projectId, name, value)
    };

    const handleSliderChange = (value, name, handleSliderChange) => {
        editProjectDetailQty(projectId, name, value, handleSliderChange);
    };

    const handleSliderInputChange = (event, minValue, maxValue) => {
        let { name, value } = event.target

        if (value < minValue) {
            value = minValue
        }

        if (value > maxValue) {
            value = maxValue
        }

        editProjectDetailQty(projectId, name, value);
    }

    const printPrice = (row) => {
        let { displayPrice, currency, price } = row
        return (
            <>
                <PriceFormat
                    decimalSeparator='.'
                    thousandSeparator={`\u00a0`}
                    fixedDecimalScale={true}
                    decimalScale={2}
                    value={displayPrice}
                    displayType={'text'}
                />{`\u00a0${currency}`}
                {currency === 'EUR' && (
                    <>
                        {`, w pln: `}
                        <PriceFormat
                            decimalSeparator='.'
                            thousandSeparator={`\u00a0`}
                            fixedDecimalScale={true}
                            decimalScale={2}
                            value={priceInPln(price, currency)}
                            displayType={'text'}
                        />{`\u00a0PLN`}
                    </>
                )}
            </>
        )
    }

    const printSelect = (row) => {
        const qtys = []
        const allowedQtys = row.availableByTheEndOfTheMonth ? row.availableByTheEndOfTheMonth : row.leftQty
        for (let i = 0; i < allowedQtys; i++) {
            const val = i + 1
            qtys.push({
                val,
                label: `${val} szt.`
            })
        }

        return (
            <TextField
                select
                label={printPrice(row)}
                value={row.qty}
                helperText={`${row.productName}, ${row.part}`}
                name={row.part}
                style={{
                    width: '100%'
                }}
                onChange={handleChange}
            >
                {qtys.map((qtyRow) => (
                    <MenuItem key={qtyRow.val} value={qtyRow.val}>
                        {qtyRow.label}
                    </MenuItem>
                ))}

            </TextField>
        )
    }

    const printSlider = (row) => {
        let allowedQtys = row.leftQty

        if (row.availableByTheEndOfTheMonth) {
            allowedQtys = row.availableByTheEndOfTheMonth

            /*if (row.leftQty < row.availableByTheEndOfTheMonth) {
                allowedQtys = row.leftQty
            }*/
        }
        allowedQtys = Math.min(row.maxQtyPerMonth, allowedQtys);

        const printSliderValue = (value) => {
            return `${value} szt.`
        }


        const sliderMarks = (row) => {
            const qty = Number(row.qty)
            const marks = [
                {
                    value: 1,
                    label: '1'
                },
                {
                    value: allowedQtys,
                    label: `${allowedQtys}`
                }
            ]

            if (qty !== 1 && qty !== allowedQtys) {
                marks.push( {
                    value: qty,
                    label: `${qty} szt.`
                })
            }

            return marks;
        }

        return (
            <>
                <Typography id="input-slider"  className={classes.sliderLabel}>
                    {`${row.productName}, ${row.part}`} - {printPrice(row)}
                </Typography>
                <Slider
                    className={classes.sliderWrap}
                    getAriaValueText={printSliderValue}
                    valueLabelDisplay="off"
                    aria-labelledby="slider"
                    value={parseInt(row.qty, 10)}
                    name={row.part}
                    step={1}
                    min={1}
                    max={Number(allowedQtys)}
                    marks={sliderMarks(row)}
                    onChange={(e, value) => handleSliderChange(value, row.part, 1)}
                    onChangeCommitted={(e, value) => handleSliderChange(value, row.part)}
                />
                <Input
                    className={classes.fieldWrap}
                    name={row.part}
                    value={parseInt(row.qty, 10)}
                    onChange={(e) => handleSliderInputChange(e, 1, Number(allowedQtys))}
                />
            </>
        )
    }

    return (
        <>
            {loading ? (
                <div style={{position: 'relative', minHeight: '10em'}} >
                    <AjaxLoading />
                </div>
            ) : (
                <>
                    {(details.length) ? (
                        <>
                            <Typography variant="button" display="block" gutterBottom className={classes.title}>
                                {_t('PP_PROJECT_DETAILS')}
                            </Typography>
                            <List>
                                {details.map((row) => {
                                    const listKey = `project-key-${row.detailsId}`
                                    return (
                                        <React.Fragment key={listKey}>
                                            <ListItem style={{paddingBottom: 'rgba(0, 0, 0, 0.12)'}}>
                                                <ListItemText>
                                                    {row.leftQty > 500 ? printSlider(row, row.leftQty) : printSelect(row)}
                                                    {showVendorIdentifier && (
                                                        <TextField
                                                            label={_t('PP_CART_VENDOR_IDENTIFIER', {pl: 'Identyfikator dostawcy', en: 'Vendor identifier'})}
                                                            value={row.vendorIdentifier || ''}
                                                            name={row.part}
                                                            style={{
                                                                width: '100%',
                                                                marginTop: '0.5em'
                                                            }}
                                                            onChange={handleVendorIdentifierChange}
                                                        />
                                                    )}
                                                </ListItemText>
                                                <ListItemSecondaryAction>
                                                    <Tooltip title={_t('CART_LIST_ACTION_REMOVE_TOOLTIP')}>
                                                        <IconButton
                                                            edge="end"
                                                            aria-label="delete"
                                                            onClick={() => removeDetail(projectId, row.part)}
                                                        >
                                                            <FontAwesomeIcon
                                                                size='xs'
                                                                icon={faTrashAlt}
                                                                style={{color: blue[500]}}
                                                            />
                                                        </IconButton>
                                                    </Tooltip>
                                                </ListItemSecondaryAction>
                                            </ListItem>
                                            <Divider />
                                        </React.Fragment>
                                    )}
                                )}
                            </List>
                        </>
                    ) : (
                        <List>
                            <ListItem>
                                <ListItemText style={{textAlign: 'center'}}>
                                    {_t('CART_LIST_ITEM_EMPTY')}
                                </ListItemText>
                            </ListItem>
                        </List>
                    )}
                </>
            )}
        </>
    )
}
